app.controller('forgetPasswordCtrl',
    ['$scope', '$rootScope', '$http', '$window', '$q', '$translate',
    function ($scope, $rootScope, $http, $window, $q, $translate) {

    $scope.user_reset = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: '',
        challenge: ''
    };

    //$scope.Email = '';

    $scope.UserNID = '';
    $scope.back = function () {
        $window.location.href = "#/dashboard";
    }

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.modalMessage = {
        message: '',
        param: {}
    };

    $scope.prepareData = function () {

        var challenge = grecaptcha.getResponse();
        console.log("grecaptcha ", challenge);
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        } else {
            $scope.user_reset.challenge = challenge;
        }

        //console.log("RDN Non BCA ", $scope.user.BankOwner);


    }


    $scope.submit = function () {
        $scope.prepareData();
        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }


        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = 'service/client.svc/Forget_Password'; // 1
        var preconfirmtranslate = "sendforgetpassword"; // 2
        var postData = { forgetpassData: $scope.user_reset } // 3
        var method = "POST"; // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login";
        });
    };

}]);
